module.exports = __webpack_public_path__ + "img/regiment.b7a4156f.png";